export default "__VITE_ASSET__FCgD3wTY__"